import Cookies from "js-cookie";
import { getMyValue } from "./index";
import { clearPracticeSpecialty } from "./practiceSpecialty";

export const AUTH_COOKIE_OPTIONS = { path: "/" };

export const SIGNUP_RESUME_ROUTES = [
  "/join-workspace",
  "/create-agentname",
  "/create-workspace",
  "/create-password",
  "/billing-details",
];

const PUBLIC_ROUTES_WITHOUT_FULL_AUTH = [
  "/signin",
  "/join-workspace",
  "/create-workspace", // TESTING: keep route open without full auth
  "/password-created",
  "/request-account-deletion",
];

export function isFullyAuthenticated(userInfo) {
  const token = getMyValue(userInfo?.token) ?? Cookies.get("token");
  const agentId = getMyValue(userInfo?.agentId) ?? Cookies.get("agent_id_vita");
  const agencyId =
    getMyValue(userInfo?.agencyId) ?? Cookies.get("agency_id_vita");
  const orgId = getMyValue(userInfo?.orgId) ?? Cookies.get("org_id_vita");

  return Boolean(token && agentId && agencyId && orgId);
}

export function clearAuthCookies() {
  const opts = AUTH_COOKIE_OPTIONS;
  Cookies.remove("token", opts);
  Cookies.remove("agent_id_vita", opts);
  Cookies.remove("route", opts);
  Cookies.remove("agency_id_vita", opts);
  Cookies.remove("org_id_vita", opts);
  Cookies.remove("selectedIndex", opts);
  localStorage.removeItem("failedMessages");
  localStorage.removeItem("datGridColumnVisibility");
  clearPracticeSpecialty();
}

let handlingMissingCredentials = false;

export function redirectForMissingCredentials() {
  if (handlingMissingCredentials) {
    return;
  }

  const path = window.location.pathname;
  if (PUBLIC_ROUTES_WITHOUT_FULL_AUTH.includes(path)) {
    return;
  }

  handlingMissingCredentials = true;
  clearAuthCookies();
  window.location.replace("/signin");
}
